<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info"/>
            计划单号：<span v-if="formData.planNo"
                           style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.planNo }}</span>
            <span v-else class="information"> 待生成</span>
            <!-- 状态 -->
            <span v-if="!dataId" class="information">制单</span>
            <span v-else-if="formData.stat==1" class="information">已创建</span>
            <span v-else-if="formData.stat==3" class="information">审核中</span>
            <span v-else-if="formData.stat==4" class="information">部分通过</span>
            <span v-else-if="formData.stat==5" class="information">全部通过</span>
            <span v-else-if="formData.stat==9" class="information">审核不通过</span>
            <span v-else-if="formData.stat==99" class="information">取消</span>


          </div>
          <div style="display:none">

            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>


          </div>
          <div class="fr">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
                       v-if="parts_plan_add && formData.id == null"
                       @click="saveData">保存
            </el-button>
            <el-button type="primary" v-if="parts_plan_commit && formData.stat==1" class="button-sty"
                       icon="el-icon-check" @click="showCommitOrCloseDialog=true;type='提交'">提交审核
            </el-button>
            <el-button type="primary" v-if="parts_plan_cancel && formData.stat==1" class="button-sty"
                       icon="el-icon-delete" @click="showCommitOrCloseDialog=true;type='取消'">取消
            </el-button>
            <el-button type="primary" v-if="parts_plan_audit && formData.stat==3" class="button-sty"
                       icon="el-icon-s-claim" @click="doAudit">审核
            </el-button>
            <!--            <el-button type="primary" v-if="parts_plan_audit && formData.stat==3" class="button-sty"-->
            <!--                       icon="el-icon-check" @click="showAuditDialog=true;type='全部通过'">全部通过-->
            <!--            </el-button>-->
            <!--            <el-button type="primary" v-if="parts_plan_audit && formData.stat==3" class="button-sty"-->
            <!--                       icon="el-icon-s-claim" @click="showAuditDialog=true;type='审核'">审核-->
            <!--            </el-button>-->
            <!--            <el-button type="primary" v-if="parts_plan_audit && formData.stat==3" class="button-sty"-->
            <!--                       icon="el-icon-close" @click="showAuditDialog=true;type='审核不通过'">审核不通过-->
            <!--            </el-button>-->
          </div>
        </div>

        <div>

          <!-- 基本信息 -->
          <dix>
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>基本信息</b></div>
                <table class="table-detail">
                  <tbody>
                  <tr>
                    <th>
                      <em class="f-red">*</em>
                      所属机构
                    </th>
                    <td v-if="justShow || currentIsSite">{{ formData.orgName }}</td>
                    <td v-else>
                      <org-search :org-id.sync="formData.orgId"
                                  :org-name.sync="formData.orgName"
                                  :org-id-path.sync="formData.orgIdPath"
                                  @clear="() => {formData.siteId = null; formData.siteName = null}"
                      />
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      网点
                    </th>
                    <td v-if="justShow || currentIsSite">{{ formData.siteName }}</td>
                    <td v-else>
                      <sitePopSearch :site-id.sync="formData.siteId"
                                     :site-name.sync="formData.siteName"
                                     :org-id.sync="formData.orgId"
                                     :org-name.sync="formData.orgName"
                                     :org-id-path.sync="formData.orgIdPath"
                      />
                    </td>

                    <th>
                      <em class="f-red">*</em>
                      计划月份
                    </th>
                    <td v-if="justShow">{{ formData.planMonth }}</td>
                    <td v-else>
                      <el-date-picker
                        v-model="formData.planMonth"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择月">
                      </el-date-picker>
                    </td>


                  </tr>
                  <tr>
                    <th>订单描述</th>
                    <td v-if="justShow" colspan="6">{{ formData.remark }}</td>
                    <td v-else colspan="6">
                      <el-input v-model="formData.remark"
                                type="text"
                                :maxlength="100"
                                size="small"
                                :clearable="true"
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>创建时间</th>
                    <td>{{formData.createTime}}</td>
                    <th>提交时间</th>
                    <td>{{formData.commitTime}}</td>
                    <th>审核时间</th>
                    <td>{{formData.checkTime}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;flex-wrap: nowrap;">
                  <div class="title first"><b>配件信息</b></div>
                  <div class="item-button" style="margin-top: 8px;">
                    <el-button type="primary" class="button-sty btn_zdy" @click="$refs.excelUpload.show()"
                               v-if="!justShow">
                      <i class="el-icon-plus"></i>
                      导入明细
                    </el-button>&nbsp;
                    <el-button type="primary" class="button-sty btn_zdy" @click="showPartsInboundDialog=true"
                               v-if="!justShow">
                      <i class="el-icon-plus"></i>
                      添加明细
                    </el-button>&nbsp;
                    <el-button v-if="!justShow"
                               type="primary" class="button-sty btn_zdy" @click="deleteData">
                      <i class="el-icon-delete"></i>
                      批量删除
                    </el-button>

                    <el-button v-if="formData.stat==3" type="primary"
                               class="button-sty btn_zdy" @click="bulkSetup('通过')">
                      勾选通过
                    </el-button>&nbsp;
                    <el-button v-if="formData.stat==3" type="primary"
                               class="button-sty btn_zdy" @click="bulkSetup('不通过')">
                      勾选不通过
                    </el-button>&nbsp;
                    <!--                    <el-button v-if="formData.stat==3" type="primary"-->
                    <!--                               class="button-sty btn_zdy" @click="bulkSetup('审核中')">-->
                    <!--                      审核中-->
                    <!--                    </el-button>-->
                  </div>
                </div>
                <div>
                  <vxe-table
                    style="margin-top: 0px;"
                    ref="vxeTable"
                    :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080',}"
                    :row-config="{height: 30,isHover: true,padding: 0,}"
                    :row-style="{ fontSize: '12px',  }"
                    show-overflow
                    height="310"
                    :column-config="{ resizable: true }"
                    @checkbox-change="selectChangeEvent"
                    @checkbox-all="selectChangeEvent"
                    :data="formData.spPartsPlanLineDTOList">
                    <vxe-column type="checkbox" width="40"/>
                    <vxe-column field="bigCategoryName" title="产品大类" width="130" :filters="[]"
                                :filter-method="filterMethod"></vxe-column>
                    <vxe-column field="smallCategoryName" title="产品小类" width="130" :filters="[]"
                                :filter-method="filterMethod"></vxe-column>
                    <vxe-column field="partsCode" title="配件编码" width="160"></vxe-column>
                    <vxe-column field="partsName" title="配件名称" width="160"></vxe-column>
                    <vxe-column field="partsSpec" title="配件型号" width="160"></vxe-column>
                    <vxe-column field="planQty" title="计划数量" width="100">
                      <template #default="{row}">
                        <vxe-input size="small" v-if="!justShow" v-model="row.planQty" type="number" min="1" max="1000"
                                   :clearable="false"></vxe-input>
                        <span v-else>{{ row.planQty }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="checkQty" title="审核数量" width="100">
                      <template #default="{row}">
                        <vxe-input size="small" v-if="formData.stat == 3"
                                   v-model="row.checkQty"
                                   type="number"
                                   :min="0"
                                   :max="row.planQty"
                                   :clearable="false"/>
                        <span v-else>{{ row.checkQty }}</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="usedQty" title="已用数量" width="100"></vxe-column>
                    <vxe-column field="checkStat" title="审核状态" width="120">
                      <template #default="{row}">
                        <span v-if="formData.stat != 3 && row.checkStat==3">审核中</span>
                        <span v-else-if="formData.stat != 3 && row.checkStat==4">部分通过</span>
                        <span v-else-if="formData.stat != 3 && row.checkStat==5">全部通过</span>
                        <span v-else-if="formData.stat != 3 && row.checkStat==9">审核不通过</span>
                        <el-select v-else-if="formData.stat == 3" v-model="row.checkStat" placeholder="请选择">
                          <!--                          <el-option :value="3" label="审核中"/>-->
                          <!-- <el-option :value="4" label="通过"/> 后端判断是否全部通过-->
                          <el-option :value="5" label="通过"/>
                          <el-option :value="9" label="不通过"/>
                        </el-select>
                      </template>
                    </vxe-column>
                    <vxe-column field="remark" title="备注">
                      <template #default="{row}">
                        <vxe-input size="small" v-if="formData.stat == 3" v-model="row.remark" :clearable="true"/>
                        <span v-else>{{ row.remark }}</span>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>

              <div class="d-item">
                <div class="title first"><b>附件信息</b></div>
                <table class="table-detail">
                  <tbody>

                  <tr v-if="!justShow">
                    <th>图片1</th>
                    <td colspan="">
                      <div class="form_picture">
                        <div>
                          <photoUpload :photo-url.sync="formData.pic1"/>
                        </div>
                      </div>
                    </td>
                    <th>图片2</th>
                    <td colspan="">
                      <div class="form_picture">
                        <div>
                          <photoUpload :photo-url.sync="formData.pic2"/>
                        </div>
                      </div>
                    </td>
                    <th>图片3</th>
                    <td colspan="">
                      <div class="form_picture">
                        <div>
                          <photoUpload :photo-url.sync="formData.pic3"/>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-else>
                    <th>图片1</th>
                    <td colspan="">
                      <div class="form_picture">
                        <div>
                          <single-photo-show :photo-url="formData.pic1"/>
                        </div>
                      </div>
                    </td>
                    <th>图片2</th>
                    <td colspan="">
                      <div class="form_picture">
                        <div>
                          <single-photo-show :photo-url="formData.pic2"/>
                        </div>
                      </div>
                    </td>
                    <th>图片3</th>
                    <td colspan="">
                      <div class="form_picture">
                        <div>
                          <single-photo-show :photo-url="formData.pic3"/>
                        </div>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </dix>

        </div>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>

    <parts-checkbox-common-dialog v-if="showPartsInboundDialog"
                                  @confirm="commitSelectedRow"
                                  :visiable.sync="showPartsInboundDialog"
                                  :param="{
                                    excludePartsIdList: this.formData.spPartsPlanLineDTOList.map(item => item.partsId),

                                    siteId: this.formData.siteId
                                  }"
                                  :enableSaleStat="true"
                                  multi="true"
    />

    <!--    <auditDialog v-if="showAuditDialog"-->
    <!--                 :id="formData.id"-->
    <!--                 :list="formData.spPartsPlanLineDTOList"-->
    <!--                 :type="type"-->
    <!--                 @closeD="closeD"-->
    <!--                 :visiable.sync="showAuditDialog"-->
    <!--                 multi="true"-->
    <!--                 @goBackIndex="goBackIndex"-->
    <!--    />-->

    <commitOrCloseDialog v-if="showCommitOrCloseDialog"
                         :visiable.sync="showCommitOrCloseDialog"
                         @close="closeD"
                         @goBackIndex="goBackIndex"
                         :data-id="formData.id"
                         :type="type"
    />

    <!--excel 模板导入 -->
    <excel-upload
      ref="excelUpload"
      title="明细批量导入"
      :url="api.spPartsPlanHeader.importLineUrl"
      temp-url="/admin/sys-file/local/file/spPartsPlanLine.xlsx"
      @refreshDataList="importLineData"
    ></excel-upload>
  </div>
</template>

<script>
import {editPageMixins, siteMixins} from "@/mixins/tabChang"
import store from "@/store";
import api from "@/api/projectApi";
import orgSearch from "@/components/formItem/orgSearch.vue"
import photoUpload from "@/components/formItem/photoUpload.vue"
import sitePopSearch from "@/components/formItem/sitePopSearch.vue"
import auditDialog from "./auditDialog.vue"
import partsInboundDialog from "@/views/dialogCommon/partsInboundDialog.vue"
import commitOrCloseDialog from './commitOrCloseDialog.vue'
import multiplePhotoShow from "@/components/formItem/multiplePhotoShow.vue"
import {mapGetters} from "vuex";
import SinglePhotoShow from "@/components/formItem/singlePhotoShow.vue";
import PartsCheckboxCommonDialog from "@/views/dialogCommon/partsCheckboxCommonDialog.vue";
import ExcelUpload from "@/components/upload/excel.vue";

export default {
  mixins: [editPageMixins, siteMixins],
  name: 'edit',
  props: {
    _dataId: [String, Number],
  },
  components: {
    ExcelUpload,
    PartsCheckboxCommonDialog,
    SinglePhotoShow,
    commitOrCloseDialog, multiplePhotoShow,
    partsInboundDialog, sitePopSearch, auditDialog,
    orgSearch, photoUpload,
  },
  data() {
    return {
      parts_plan_add: false,
      parts_plan_edit: false,
      parts_plan_audit: false,
      parts_plan_cancel: false,
      parts_plan_commit: false,

      type: null,
      justShow: false,
      showPartsInboundDialog: false,
      showCommitOrCloseDialog: false,
      currentMonth: null,

      showAuditDialog: false,
      showCloseDialog: false,
      selectedData: [],

      showPhotoList: [],
      formData: {
        id: null,
        remark: null,
        planNo: null,  // 计划单号;前缀"PL"+年月日+6位流水号
        planMonth: null,
        orgId: null,  // 所属中心，关联脚手架机构表sys_dept.dept_id
        orgName: null,  // 所属机构名称,冗余字段
        orgIdPath: null,  // 所属机构ID路径,冗余字段.重要
        siteId: null,  // 网点ID,关联sn_user.id;
        stat: 0,  // 单据状态:1已创建;3审核中;4部分通过;5全部通过;9审核不通过;99取消
        pic1: null,  // 图片1
        pic2: null,  // 图片2
        pic3: null,  // 图片3
        spPartsPlanLineDTOList: [],

        siteName: null,
      },
      rules: {
        remark: [{required: false, prop: '订单描述', type: 'string', maxlength: 100}],
        planMonth: [{required: true, prop: '计划月份',}, {type: 'string', maxlength: 10, msg: '计划月份异常'}],
        orgId: [{required: true, prop: '所属中心'}],
        siteId: [{required: true, prop: '网点'}],
        spPartsPlanLineDTOList: [{
          required: true, prop: '配件明细', type: 'list', rules: {
            planQty: [{prop: '计划数量', required: true, type: 'number'}]
          }
        }],
        pic1: [{type: 'string', prop: '图片1'}],
        pic2: [{type: 'string', prop: '图片2'}],
        pic3: [{type: 'string', prop: '图片3'}]
      },

      show3: false,
      node: true,


      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    },
    ...mapGetters(["permissions"])
  },
  created() {
    this.parts_plan_add = this.permissions['parts_plan_add']
    this.parts_plan_edit = this.permissions['parts_plan_edit']
    this.parts_plan_audit = this.permissions['parts_plan_audit']
    this.parts_plan_cancel = this.permissions['parts_plan_cancel']
    this.parts_plan_commit = this.permissions['parts_plan_commit']

    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
    this.formData.planMonth = year + '-' + month
    this.getData()
  },
  watch: {
    // 'formData.orgId': {
    //   handler(n) {
    //     if (!n) {
    //       this.formData.siteName = null
    //       this.formData.siteId = null
    //     }
    //   },
    //   deep: true
    // },
    // 'formData.spPartsPlanLineDTOList': {
    //   deep: true,
    //   handler(n) {
    //     if (n && n.length > 0) {
    //
    //     }
    //   }
    // }
  },
  methods: {
    importLineData(data) {
      console.log('导入明细', data)
      if (!this.formData.spPartsPlanLineDTOList || this.formData.spPartsPlanLineDTOList.length == 0) {
        this.formData.spPartsPlanLineDTOList = data
      } else {
        this.formData.spPartsPlanLineDTOList.forEach(item => {
          data.forEach(item1 => {
            if (item1.partsId == item.partsId) {
              item.planQty = Number(item.planQty) + Number(item1.planQty)
            }
          })
        })
      }
    },


    // 重写方法，用于当前用户为网点用户时自动设置网点数据
    setSiteData() {
      this.formData.siteId = this.currentSiteData.id
      this.formData.siteName = this.currentSiteData.userName
      this.formData.orgId = this.currentSiteData.snSiteInfoDTO.orgId
      this.formData.orgName = this.currentSiteData.snSiteInfoDTO.orgName
      this.formData.orgIdPath = this.currentSiteData.snSiteInfoDTO.orgIdPath
    },

    // 列表过滤
    filterMethod({cellValue, value}) {
      return cellValue === value
    },

    // 设置明细表筛选条件
    setFilter() {
      let n = this.formData.spPartsPlanLineDTOList
      let vxeTable = this.$refs.vxeTable
      let bigCategoryNameField = vxeTable.getColumnByField('bigCategoryName')
      let smallCategoryNameField = vxeTable.getColumnByField('smallCategoryName')

      if (bigCategoryNameField) {
        let temp = []
        n.forEach(item => {
          temp.push({
            label: item.bigCategoryName,
            value: item.bigCategoryName
          })
        })
        const res = new Map();
        temp = temp.filter((item) => !res.has(item['value']) && res.set(item['value'], 1))
        vxeTable.setFilter(bigCategoryNameField, temp)
      }

      if (smallCategoryNameField) {
        let temp = []
        n.forEach(item => {
          let smallCategoryName = item.smallCategoryName
          if (smallCategoryName) {
            temp.push({
              label: smallCategoryName,
              value: smallCategoryName
            })
          } else {
            temp.push({
              label: '无',
              value: smallCategoryName
            })
          }
        })
        const res = new Map();
        temp = temp.filter((item) => !res.has(item['value']) && res.set(item['value'], 1))
        vxeTable.setFilter(smallCategoryNameField, temp)
      }
    },


    // 审核
    doAudit() {
      this.$validate(this.formData, {
        spPartsPlanLineDTOList: [{
          prop: '配件明细', required: true, type: 'list', rules: {
            checkQty: [{prop: '审核数量', required: true}]
          }
        }]
      }).then(() => {
        this.$baseConfirm('您确定要进行审核吗？').then(() => {
          this.$http({
            url: api.spPartsPlanHeader.auditDataUrl,
            method: 'post',
            data: this.formData
          }).then(res => {
            this.$message.success('操作成功')
            this.$emit('goBackIndex')
          })
        })
      })
    },

    // 审核批量设置
    bulkSetup(type) {
      let selectedData = this.selectedData;
      if (!selectedData || selectedData.length === 0) {
        this.$message.error('请先选中明细数据')
        return
      }

      selectedData.forEach(item => {
        if (type === '通过') {
          item.checkStat = 5;
          item.checkQty = item.planQty
        } else if (type === '不通过') {
          item.checkStat = 9;
          item.checkQty = 0
        } else if (type === '审核中') {
          item.checkStat = 3;
          item.checkQty = 0
        }
      })
    },

    commitSelectedRow(data) {
      data = data.map(item => {
        return {
          partsId: item.id,
          partsName: item.partsName,
          partsCode: item.partsCode,
          partsSpec: item.partsSpec,
          smallCategoryName: item.smallCategoryName,
          bigCategoryName: item.bigCategoryName,
          planQty: 1,
          checkQty: 0,
          usedQty: 0,
          checkStat: 3,
          isNew: true
        }
      })
      console.log('配件明细添加', data)
      this.formData.spPartsPlanLineDTOList.push(...data)
      this.setFilter()
    },


    // 抽屉关闭
    closeD() {
      this.showCommitOrCloseDialog = false
      this.showAuditDialog = false
    },


    deleteData() {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        let temp = this.formData.spPartsPlanLineDTOList
        this.selectedData.forEach(item => {
          temp = temp.filter(item1 => item1.partsId != item.partsId)
        })
        this.formData.spPartsPlanLineDTOList = temp
        this.setFilter()
      })
    },


    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },


    saveData() {
      this.$validate(this.formData, this.rules).then(() => {
        this.$baseConfirm('您确定要保存吗？').then(() => {
          this.$mask.open()

          this.$http.post(
            this.formData.id == null ? api.spPartsPlanHeader.addDataUrl : api.spPartsPlanHeader.updateDataUrl,
            this.formData
          ).then(res => {
            this.$message.success('保存成功')
            this.goBackIndex()
            this.$mask.close()

          }).catch(() => {
            this.$message.error("保存失败！");
            this.$mask.close()
          });
        })
      })
    },

    getData() {
      console.log('getData')
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http.post(api.spPartsPlanHeader.getDataUrl, {id: this.dataId}).then(res => {
          this.formData = res.data.data
          if (this.formData.stat == 3) {
            this.formData.spPartsPlanLineDTOList.forEach(item => {
              item.checkStat = 5
              item.checkQty = item.planQty
            })
          }
          this.justShow = this.formData.stat != 1
          this.setFilter()
        })
      }
    },

    commit() {

    },

    cancel() {

    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-image {
  margin-right: 15px;
}

#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  > span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  > div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}


::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover > td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

// #containt .detail-wrap .d-cont {
//   overflow: unset !important;
// }

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}

#containt .table-detail tbody tr td {
  width: 16vw !important;;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .table-detail tbody tr th {
  width: 6vw !important;
}

#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}
</style>
